import { insertChars } from './insertChars';
import { preFormatFilterNumericOnly } from './private';
/**
 * Filters and formats a string into a us social security number in the format of 111-22-3333
 * @param {string} value - The original string
 */
export var ssnFormatter = function (value) {
    value = insertChars(value.toString(), [
        { char: '-', index: 3 },
        { char: '-', index: 6 },
    ], preFormatFilterNumericOnly);
    return value.substring(0, 11);
};
